import Linkedin from "../Assets/Icons/Icons Contatos/Linkedin.svg";
import Mail from "../Assets/Icons/Icons Contatos/Emaill.svg";
import Github from "../Assets/Icons/Icons Redes - Header/Github.svg";

export const contactsData = [
  {
    id: 1,
    platform: "LinkedIn",
    icon: Linkedin,
    description:
      "Conheça minha trajetória profissional, conexões e recomendações.",
    url: "https://www.linkedin.com/in/emersonssales/",
    label: "Conectar",
  },
  {
    id: 2,
    platform: "E-mail",
    icon: Mail,
    description:
      "Envie sua proposta, dúvida ou solicitação. Resposta rápida garantida.",
    url: "mailto:contatosalesdev@gmail.com",
    label: "Enviar e-mail",
  },
  {
    id: 3,
    platform: "GitHub",
    icon: Github,
    description:
      "Explore meus repositórios, códigos e projetos abertos mais recentes.",
    url: "https://github.com/saalesz",
    label: "Ver Projetos",
  },
];
